import React, { Component } from 'react';
import intl from 'react-intl-universal';
import Select from './Select';
import styles from './RoomSurfaces.module.scss';

import ceilingMaterials from '../../data/ceilingMaterials';
import wallMaterials from '../../data/wallMaterials';
import floorMaterials from '../../data/floorMaterials';

class RoomSurfaces extends Component {
  render() {
    // Translate on render so that language switch is visible immediately
    const ceilingMaterialNames = ceilingMaterials.map(m =>
      intl.get(m.name, { alpha: m.absorptionCoefficient }).d(m.name)
    );
    const wallMaterialNames = wallMaterials.map(m =>
      intl.get(m.name, { alpha: m.absorptionCoefficient }).d(m.name)
    );
    const floorMaterialNames = floorMaterials.map(m =>
      intl.get(m.name, { alpha: m.absorptionCoefficient }).d(m.name)
    );

    return (
      <div className={styles.container}>
        <h3>{intl.get('topNav.surfaces')}</h3>

        <div className={styles.controllerContainer}>
          <Select
            label={intl.get('surfaces.ceiling')}
            names={ceilingMaterialNames}
            value={this.props.ceilingMaterialIndex}
            onChange={this.props.onCeilingMaterialChanged}
          />
        </div>

        <div className={styles.controllerContainer}>
          <Select
            label={intl.get('surfaces.walls')}
            names={wallMaterialNames}
            value={this.props.wallMaterialIndex}
            onChange={this.props.onWallMaterialChanged}
          />
        </div>

        <div className={styles.controllerContainer}>
          <Select
            label={intl.get('surfaces.floor')}
            names={floorMaterialNames}
            value={this.props.floorMaterialIndex}
            onChange={this.props.onFloorMaterialChanged}
          />
        </div>
      </div>
    );
  }
}

export default RoomSurfaces;
